import { axios } from '../utilities';

const getInterviewsInfo = (customerId, projectId) => axios.get('api/interviews', { params: { customerId, projectId } });

const sendInterviewInvite = (interview) => axios.post('api/interviews', { interview });

const updateInterview = (interview) => axios.put('api/interviews', { interview });

// TODO: consider splitting and uploading file in chunks with multiply requests for better performance with huge files
// NOTE: Uploading with chunks might be valuable in case of considered further UX improvements like progressbar, possibility to abort uploading etc.
const attachFileToInterview = (projectId, interviewId, file) => {
  const UPLOAD_TIMEOUT = 10 * 60 * 1000;
  const formData = new FormData();
  formData.append('interviewFile', file);
  formData.append('originalSize', file.size);
  return axios.post(
    `api/interviews/${interviewId}/attach-file`,
    formData,
    {
      params: {
        projectId,
        interviewId,
      },
      headers: {
        'Content-Type': 'multipart/form-data',
      },
      timeout: UPLOAD_TIMEOUT,
    },
  );
};

const deleteFileFromInterview = (interviewId, interviewFileId) =>
  axios.put(`api/interviews/${interviewId}/delete-file`, { interviewFileId });

const downloadFileOfInterview = (interviewId, interviewFileId) =>
  axios.post(`api/interviews/${interviewId}/download-file`, { interviewFileId });

const toggleAudioFilesRequired = (interviewId) =>
  axios.put(`api/interviews/${interviewId}/toggle-audio-files-required`);

const transcribeFileOfInterview = (interviewFileId) =>
  axios.post('api/interviews/transcribe-file', { interviewFileId }, { timeout: 10 * 60 * 1000 });

export default {
  getInterviewsInfo,
  sendInterviewInvite,
  updateInterview,
  attachFileToInterview,
  deleteFileFromInterview,
  downloadFileOfInterview,
  toggleAudioFilesRequired,
  transcribeFileOfInterview,
};
